<template>
  <div class="about">
    <!-- <h1>Søke barnehageplass</h1> -->
    <!-- <img class="image1" alt="Knerten logo" src="../assets/Bilde1.png" height="300px">  -->
    <h1>Ledig barnehageplass</h1>
     <!-- <p>Vi håper du vil søke barnehageplass hos oss.</p>
    <p>Søking av barnehagplass gjøres gjennom Re kommune sine nettsider.</p> -->


<b-container class="bv-example-row" >
  <!-- <b-container > -->
  <b-row align-h="center">
    <!-- <b-col cols="3">
      <img alt="Knerten logo" src="../assets/Bilde1.png" class="image1"> 
      
    </b-col> -->
    <b-col cols="12">
      <!-- <p>
      Vi håper du vil søke barnehageplass hos oss, det er ledige plasser fra høsten 2020. 
Søknad om barnehageplass gjøres gjennom Re kommune sine nettsider. 
Det er viktig å sette Knerten familiebarnehage som alternativ 1 når du velger barnehager for å kunne bli tilbudt plass.
</p> -->

<p>

Ønsker du barnehageplass der barnet ditt opplever <b>trygghet</b>, blir <b>sett og hørt</b>, lærer seg å <b>bry seg</b> om andre og møter <b>kjente voksne</b> hver dag?
Knerten Familiebarnehage har ledige plasser fra august 2020.
Søknadsfrist er 15.februar. Det er viktig å sette Knerten familiebarnehage som 1. alternativ for å kunne bli tilbudt plass hos oss.
</p>
<br/>
<p>
Søknad sendes på Tønsberg kommunes hjemmesider.
</p>
<br/>
<p>
Knerten familiebarnehage er en privat barnehage som ligger i Brekkeåsen, Våle med plass til 10 barn i alderen 1-6 år. 
</p>
<br/>
<p>
Eier og leder av barnehagen, Bente W. Strøm er utdannet barnehagelærer.
Ønsker dere å ta en prat eller komme innom, kontakt meg på: 95892360 😊
</p>


      
    </b-col>
    <!-- <b-col cols="3">
      <img alt="Knerten logo" src="../assets/Bilde1.png" class="image1"> 
      
    </b-col> -->


  </b-row>
    <div class="button">
      <!-- <button v-on:click="onClickSok">Søk barnehageplass</button> -->
      <button type="button" class="btn btn-primary btn-lg" v-on:click="onClickSok">Søk barnehageplass</button>
    </div>
  <b-row class="pb-4 justify-content-md-center" v-if="$vssWidth > 1250">
    <b-col md="12" lg="2" align-h="center">
      <img alt="Knerten logo" src="../assets/Bilde1.png" width="150px"> 
    </b-col>
    <b-col md="12" lg="6" align-h="center">
      <img alt="Knerten logo" src="../assets/Bilde3.png" width="400px"> 
    </b-col>
    <b-col md="12" lg="2" align-h="center">
      <img alt="Knerten logo" src="../assets/Bilde2.png" width="150px"> 
    </b-col>
  </b-row >
<b-row class="pb-4 justify-content-md-center" v-if="$vssWidth <= 1250">
    <b-col xs="10" sm="10" md="10" align-h="center">
      <img alt="Knerten logo" src="../assets/Bilde3.png" :class="{'bigImage': $vssWidth <= 500, 'image1': $vssWidth > 500 }"> 
    </b-col>
    <b-col xs="6" sm="5" md="4" class="mr-2" >
      <img alt="Knerten logo" src="../assets/Bilde2.png" width="200px"> 
    </b-col>
    <b-col v-if="$vssWidth > 575" xs="6" sm="5" md="4" class="ml-2">
      <img alt="Knerten logo" src="../assets/Bilde1.png" width="200px"> 
    </b-col>
  </b-row >
</b-container>
    
  </div>
</template>

<script>
export default {
  methods: {
    onClickSok() {
      window.location.href = 'https://barnehage.visma.no/tonsberg';
    },
  },
  
}
</script>

<style>
.btn {
  background-color: #667CB0;
  border-color: #667CB0;
}
.btn:hover {
  background-color: white;
  color: #667CB0;
  /* font-size: 20px; */
}
 .button {
   padding: 30px;
   /* background-color: aqua; */
 }
 .image1 {
   width: 500px
 } 

 .back {
   background-color: aqua;

 }
 .bigImage {
   max-width: 90%;
 }

 @media screen and (min-width: 1001px) {
  p {
    font-size:1.25vw;
    margin-bottom: 0%;
  }
}
</style>

